namespace Umbrella.CustomerService {
    @Pipe('CustomerService', 'dotToNewLine')
    class DotToNewLineFilter {
        public transform(text: string): string {
            return text.split(').').join(').\r');
        }
    }
}
